import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { httpResource } from '@angular/common/http';
import { TranslatePipe } from '@ngx-translate/core';
import { parseThirdPartyLicenses } from './third-party-licenses';

/** Written by release builds next to index.html (tools/build.mjs); absent in `ng serve`. */
export const THIRD_PARTY_LICENSES_URL = './3rdpartylicenses.txt';

@Component({
  selector: 'andor-licenses',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './licenses.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './licenses.scss',
})
export class Licenses {
  protected readonly file = httpResource.text(() => THIRD_PARTY_LICENSES_URL);
  protected readonly query = signal('');
  protected readonly entries = computed(() =>
    this.file.hasValue() ? parseThirdPartyLicenses(this.file.value()) : []
  );
  protected readonly filtered = computed(() => {
    const query = this.query().trim().toLowerCase();
    if (!query) return this.entries();
    return this.entries().filter(
      (entry) =>
        entry.name.toLowerCase().includes(query) || entry.license?.toLowerCase().includes(query)
    );
  });
}
